import Routes from "modules/Routes";
import store from "modules/store";
import React from "react";
import { Provider } from "react-redux";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default App;
